class MATALogoBar {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      marquee: ".logo-bar__marquee",
      control: ".logo-bar__control-button",
      helper: ".logo-bar__marquee-helper",
      entry: ".logo-bar__marquee-entry",
    };

    this.init();
  }

  init() {
    this.$marquee = this.$element.find(this.selectors.marquee);
    this.$control = this.$element.find(this.selectors.control);
    this.$helper = this.$element.find(this.selectors.helper);
    this.$entry = this.$element.find(this.selectors.entry);
    this.$marquee = this.$element.find(this.selectors.marquee);
    this.$carousel = new Flickity(this.$marquee.get(0), {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      imagesLoaded: true
      // setGallerySize: true
    });

    this.initCarousel();
  }

  initCarousel() {
    this.$carousel.x = 0;

    this.play();

    this.$marquee.on("pointerDown.flickity", () => {
      this.pause();
    });
    // this.$marquee.on("mouseleave", () => {
    //   if ($(window).width() <= 1023) return;
    //   this.play();
    // });
  }

  play() {
    this.$carousel.x -= 0.9;

    this.$carousel.settle(this.$carousel.x);

    this.requestId = window.requestAnimationFrame(this.play.bind( this ));
  }

  pause() {
    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId);
      this.requestId = undefined;
    }
  }
}